import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { ExpensesSubCategoryDto } from './expenses-sub-category.dto';


export class AllExpensesSubCategoryResponse extends GlobalResponseObject{
    data?: ExpensesSubCategoryDto[];

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
     constructor(status:boolean, intlCode:number, internalMessage:string, data?: ExpensesSubCategoryDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}